import { useIntl } from 'react-intl';

export const useTranslationMessages = () => {
  const intl = useIntl();

  const t = (id: string, values = {}) => intl.formatMessage({ id }, values);

  return { t, intl };
};
